import React, { FC, Ref, useRef, useState } from 'react';
import { isFunction, isObject } from 'lodash-es';

import { Trigger } from '@arco-design/web-react';
import { useComposeRef } from '@shared/components/base/Tooltip/utils/useComposeRef';
import { useScrollDisabled } from '@shared/components/base/Tooltip/utils/useContainerWatch';

import { IBaseTriggerProps } from './interface';
import { BASE_TRIGGER_DEFAULT_ALIGN } from './config';
import { OtherPopupRecord } from './other';

export const BaseTrigger: FC<IBaseTriggerProps> = (props) => {
	const { children, onVisibleChange, scroll = false, ...rest } = props;

	// --- 显示时禁用后方背景滚动 ---
	const [visible, setVisible] = useState(false);
	const ref = useRef(null);

	let childRef: Ref<IBaseTriggerProps['children']> = null;

	if (children && isObject((children as any).ref)) {
		childRef = (children as any).ref;
	}

	const mergedRef = useComposeRef(childRef, ref);

	const handleVisibleChange = (vis: boolean) => {
		setVisible(vis);
		isFunction(onVisibleChange) && onVisibleChange(vis);
		setTimeout(() => {
			OtherPopupRecord['arco_trigger'] = vis;
		});
	};

	useScrollDisabled(ref.current, visible && !scroll && rest.popupVisible !== false);

	return (
		<Trigger
			escToClose
			popupAlign={BASE_TRIGGER_DEFAULT_ALIGN}
			{...rest}
			onVisibleChange={handleVisibleChange}
		>
			{React.cloneElement(children, { ref: mergedRef })}
		</Trigger>
	);
};
